import React from 'react'

function CalendarPage() {
  return (
    <div>CalendarPage</div>
  )
}

export default CalendarPage